import { WizardHeader } from '../../../../../../components/Elements/Modal/components/WizardHeader/WizardHeader'
import { ConnectionModalProps, platformWizardSteps } from '../../../common/Common.models'
import { ConnectionModalContainer } from '../../../common/Common.styled'
import { useSteps } from '../../../../hooks/useSteps'
import { CONNECTION_STATUS } from '../../../../models'
import React from 'react'

import { MetaConnectModalContent } from './MetaConnectionModalContent'

export const MetaConnectionModal = ({
  connectionStatus,
  onClose,
  isEnabled,
}: ConnectionModalProps) => {
  const stepsForPlatform = platformWizardSteps.meta.steps

  const getInitialStep = () => (connectionStatus === CONNECTION_STATUS.CONNECTED ? 2 : 1)
  const stepByStatus = getInitialStep()

  const { setStep, onBack, currentStep, isBackDisabled } = useSteps({
    initialStep: stepByStatus,
    disableBackToFirstStep: true,
  })

  return (
    <ConnectionModalContainer id={'meta-connection-modal'}>
      <WizardHeader
        onChangeStep={setStep}
        currentStep={currentStep}
        steps={stepsForPlatform}
        isEnabled={isEnabled}
      />
      <MetaConnectModalContent
        currentStep={currentStep}
        setStep={setStep}
        closeModal={onClose}
        onBack={onBack}
        isBackDisabled={isBackDisabled}
      />
    </ConnectionModalContainer>
  )
}
